import React, { Dispatch, SetStateAction, useRef, useState } from 'react'
import styled from '@emotion/styled'
import { Colors, Levels, Shapes } from 'src/components/theme'

export type MapOverlayContextProps = {
  portalRef: React.RefObject<HTMLDivElement>
  isActive: boolean
  setActive: Dispatch<SetStateAction<boolean>>
}

export const MapOverlayContext = React.createContext<MapOverlayContextProps | undefined>(undefined)

export const useMapOverlayContext = () => {
  const result = React.useContext(MapOverlayContext)
  if (!result) {
    throw new Error('No MapOverlayProvider found')
  }
  return result
}

type MapOverlayProviderProps = {
  children?: React.ReactNode
}

export const MapOverlayProvider = (props: MapOverlayProviderProps) => {
  const { children } = props
  const portalRef = useRef<HTMLDivElement>(null)
  const [isActive, setActive] = useState(false)
  const providerValues: MapOverlayContextProps = {
    portalRef: portalRef,
    isActive,
    setActive,
  }
  return <MapOverlayContext.Provider value={providerValues}>{children}</MapOverlayContext.Provider>
}

const Wrapper = styled.div`
  position: fixed;
  top: 20px;
  left: 20px;
  width: calc(100vw - 40px);
  height: calc(100vh - 40px);
  z-index: ${Levels.modal};
  box-shadow: ${Colors.BOX_SHADOW};
  overflow: hidden;
  background-color: ${Colors.bgDark};
  transition: opacity 0.3s;
  border-radius: ${Shapes.borderRadius}px;
  border: 1px solid ${Colors.border};
  padding: ${Shapes.spacing[2]}px;
  & > div {
    border-radius: ${Shapes.borderRadius}px;
    border: 1px solid ${Colors.border};
  }
`

export const MapOverlayModal = () => {
  const context = useMapOverlayContext()

  const style = {
    display: context.isActive ? 'block' : 'none',
    opacity: context.isActive ? '1' : '0',
  }

  return <Wrapper style={style} ref={context.portalRef}></Wrapper>
}
